import { Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { saveShippingAddress } from '../../slices/cartSlice';
import ShippingMethods from './ShippingMethods';
import ShippingContact from './ShippingContact';
import SectionTitle from './SectionTitle';

// Shipping section: writes straight into the same cartSlice.shippingAddress
// the wizard's ShippingScreen used, so the address persists to localStorage
// exactly as before. Inputs are controlled from Redux (single source of truth).
// `showErrors`: set by OnePageStoreScreen after a blocked 送出訂單, so the
// missing contact fields light up red.
const ShippingSection = ({ showErrors = false }) => {
  const dispatch = useDispatch();
  const { shippingAddress } = useSelector((state) => state.cart);

  const onField = (field) => (e) => {
    dispatch(saveShippingAddress({ ...shippingAddress, [field]: e.target.value }));
  };

  return (
    <>
      <SectionTitle step={3}>運送資訊</SectionTitle>
      <ShippingMethods />
      {/* 配達時段 (黑貓 only) + Email / 手機 — mandatory for the carrier */}
      <ShippingContact showErrors={showErrors} />
      <h6 className="op-subtitle">收件地址</h6>
      {/* UI polish: 2-column grid — Address full width, City + Postal side by side */}
      <Form>
        <Form.Group controlId="address" className="my-2">
          <Form.Label>地址</Form.Label>
          <Form.Control
            type="text"
            placeholder="請輸入地址"
            value={shippingAddress?.address || ''}
            onChange={onField('address')}
          ></Form.Control>
        </Form.Group>
        <Row>
          <Col md={6}>
            <Form.Group controlId="city" className="my-2">
              <Form.Label>縣市</Form.Label>
              <Form.Control
                type="text"
                placeholder="請輸入縣市"
                value={shippingAddress?.city || ''}
                onChange={onField('city')}
              ></Form.Control>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="postalCode" className="my-2">
              <Form.Label>郵遞區號</Form.Label>
              <Form.Control
                type="text"
                placeholder="請輸入郵遞區號"
                value={shippingAddress?.postalCode || ''}
                onChange={onField('postalCode')}
              ></Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group controlId="country" className="my-2">
          <Form.Label>國家</Form.Label>
          <Form.Control
            type="text"
            placeholder="請輸入國家"
            value={shippingAddress?.country || ''}
            onChange={onField('country')}
          ></Form.Control>
        </Form.Group>
      </Form>
    </>
  );
};

export default ShippingSection;
